// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { People, TableDocument } from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  customers: People,
  contactForm: TableDocument,
  connectRequests: TableDocument
};

// ==============================|| MENU ITEMS - CUSTOMERS ||============================== //

const customers: NavItemType = {
  id: 'customer-group',
  title: <FormattedMessage id="common.menu.customers.group" />,
  type: 'group',
  children: [
    {
      id: 'customers',
      title: <FormattedMessage id="common.menu.customers.group" />,
      type: 'item',
      url: '/customers',
      icon: icons.customers
      // breadcrumbs: false
    },
    {
      id: 'contact-forms',
      title: <FormattedMessage id="contactForm.title" />,
      type: 'item',
      url: '/contact-forms',
      icon: icons.contactForm
      // breadcrumbs: false
    },
    {
      id: 'connect-requests',
      title: <FormattedMessage id="connectRequests.settings.title" />,
      type: 'item',
      url: '/connect-requests',
      icon: icons.connectRequests
      // breadcrumbs: false
    }
  ]
};

export default customers;
